module.exports = __webpack_public_path__ + "static/media/marker_shopping.f91f8d20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/markers/marker_shopping.svg
// module id = 285
// module chunks = 0